import { EAuthorizationType, EDocumentStatus, EDocumentType, EEntidadFederativa, EFundamentoServicioSocial, EGraduationMode, EPeriodType, ETipoEstudioAntecedente, IDegree } from '@shared/types'

export const CDegree: IDegree = {
	cadenaOriginal: '',
	data: {
		Antecedente: {
			entidadFederativa: '',
			fechaTerminacion: '',
			idEntidadFederativa: EEntidadFederativa.AGUASCALIENTES,
			idTipoEstudioAntecedente: ETipoEstudioAntecedente.LICENCIATURA,
			institucionProcedencia: '',
			noCedula: '',
			tipoEstudioAntecedente: ''
		},
		Carrera: {
			idCarrera: '',
			nombreCarrera: '',
			cveCarrera: '',
			clavePlan: '',
			idNivelEstudios: 81,
			idTipoPeriodo: EPeriodType.SEMESTRE,
			calificacionMaxima: 0,
			calificacionMinima: 0,
			calificacionMinimaAprobatoria: '',
			tipoPeriodo: 'SEMESTRE',
			autorizacionReconocimiento: '',
			fechaInicio: '',
			fechaTerminacion: '',
			idAutorizacionReconocimiento: EAuthorizationType.ACTA_DE_SESION,
			numeroRvoe: ''
		},
		Expedicion: {
			cumplioServicioSocial: 0,
			entidadFederativa: EEntidadFederativa.AGUASCALIENTES,
			fechaExamenProfesional: '',
			fechaExencionExamenProfesional: '',
			fechaExpedicion: '',
			fundamentoLegalServicioSocial: 'NO APLICA',
			idFundamentoLegalServicioSocial: EFundamentoServicioSocial.NO_APLICA,
			idEntidadFederativa: EEntidadFederativa.AGUASCALIENTES,
			idModalidadTitulacion: EGraduationMode.OTRO,
			modalidadTitulacion: ''
		},
		FirmaResponsables: {},
		Institucion: {
			cveInstitucion: '',
			nombreInstitucion: ''
		},
		Profesionista: {
			curp: '',
			nombre: '',
			primerApellido: '',
			segundoApellido: '',
			correoElectronico: ''
		},
		TituloElectronico: {
			folioControl: '',
			version: '',
			xmlns: ''
		},
		insertTime: 0,
		numeroControl: '',
		row: 0
	},
	xmlAuthenticated: '',
	id: '',
	type: EDocumentType.DEGREE,
	status: EDocumentStatus.PENDING,
	folioControl: '',
	date: 0,
	package: 0,
	success: false
}
